const COLOR_SPECTRUMS = [
  "lightest",
  "light",
  "lighter",
  "default",
  "dark",
  "darker"
];
function getSpectrumKeyFromColor(_color) {
  const color = _color.toLowerCase();
  return COLOR_SPECTRUMS.find((spectrum) => color.endsWith(spectrum)) ?? "default";
}
function upperFirst(str) {
  return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
}
function getColorNameFromSpectrumByLevel({
  level,
  color
}) {
  const originSpectrum = getSpectrumKeyFromColor(color);
  const originIndex = COLOR_SPECTRUMS.findIndex(
    (spectrum) => spectrum === originSpectrum
  );
  const spectrumKey = color.split(upperFirst(originSpectrum))[0];
  const nextIndex = originIndex + level;
  if (nextIndex < 0 || nextIndex > COLOR_SPECTRUMS.length - 1) {
    return;
  }
  const nextSpectrum = COLOR_SPECTRUMS[nextIndex];
  return `${spectrumKey}${nextSpectrum !== "default" ? upperFirst(nextSpectrum) : ""}`;
}

export { getColorNameFromSpectrumByLevel };
//# sourceMappingURL=spectrum.mjs.map
